import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ReportTemplate } from '@src/api/reports';
import { BaseTableFormComponent, FormComponent, RowComponent, FieldComponent } from '@src/app/components';
import { fixNullToUndefined, fixUndefinedToNull } from '@src/app/utils';
import { CaptionPipe } from '@src/app/pipes';

import { TABLE_NAME } from '../../constants';

import { FormDataType } from './types';
import { createForm } from './utils';

@Component({
  selector: 'edit-form',
  standalone: true,
  imports: [ReactiveFormsModule, FormComponent, RowComponent, FieldComponent, CaptionPipe, InputTextModule],
  templateUrl: './edit-form.component.html',
  styleUrl: './edit-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditFormComponent extends BaseTableFormComponent<FormDataType, ReportTemplate> {
  readonly tableName = TABLE_NAME;

  constructor() {
    super(createForm());
  }

  override mapApiDataToFormData(data: ReportTemplate): FormDataType {
    const { uuid, filename, name, description } = data;

    const formData: FormDataType = {
      uuid,
      filename: fixUndefinedToNull(filename),
      name: fixUndefinedToNull(name),
      description: fixUndefinedToNull(description),
    };

    return formData;
  }

  override mapFormDataToApiData(data: FormDataType): ReportTemplate {
    const { uuid, filename, name, description } = data;

    const apiData: ReportTemplate = {
      uuid,
      filename: fixNullToUndefined(filename),
      name: fixNullToUndefined(name),
      description: fixNullToUndefined(description),
    };
    return apiData;
  }
}
